import React from 'react';
import Teaching from '../components/Teaching';

const TeachingPage: React.FC = () => {
  return (
    <div className="pt-16">
      <Teaching />
    </div>
  );
};

export default TeachingPage;
